module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('custom-table', {
    attrs: {
      "edit": "/graveyards/{:id}",
      "add": "/graveyards/new",
      "default-sort": _vm.defSort,
      "search": "",
      "src-model": _vm.$store.getters.models('graveyards'),
      "cols": _vm.cols
    },
    on: {
      "print": _vm.print
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Friedhofsverwaltung")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07e31dce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GraveyardOverview.vue
// module id = 424
// module chunks = 0